/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import {
    CONFIRMATION_BOX_BTN_IDS,
} from './confirmationDialogConstants';
import CONFIRMATION_CTAS_REPO from './confirmationDialogActionsRepo';
import {
    AppDialogAction, AppDialogDescription,
} from '../../../../stores/dialog';
import TranslationUtil from '../../../translation';
import { APP_DIALOG } from '../../../enums';
import AppModelMapper from '..';

class RetryableErrorModelMapper {
    updateDialogRepo(appData) {
        const actionName = AppModelMapper.getActionInProgress(appData);
        const type = APP_DIALOG.DESCRIPTION_TYPE.PARAGRAPH;
        const heading = TranslationUtil.getMessage(`ccx.confirmation.retryable.error.${actionName}.title`,
            {
                appName: appData.display_name,
            });
        const description = [
            new AppDialogDescription(type, TranslationUtil.getMessage('ccx.confirmation.retryable.error.desc.error.code', { errorCode: appData.error_details.error_code })),
            new AppDialogDescription(type, TranslationUtil.getMessage(`ccx.confirmation.retryable.error.desc.${actionName}.${appData.error_details.error_code}`,
                {
                    appName: appData.display_name,
                })),
        ];
        const actionList = [];
        actionList.push(new AppDialogAction({
            ...CONFIRMATION_CTAS_REPO[CONFIRMATION_BOX_BTN_IDS.PRIMARY],
            actionId: CONFIRMATION_BOX_BTN_IDS.DONE,
            localizedText: TranslationUtil.getMessage('ccx.confirmation.btn.done'),
            ariaLabel: 'DONE',
        }));
        return {
            heading, description, actionList,
        };
    }
}
export default new RetryableErrorModelMapper();
